import ls from "local-storage";
import store from "@/store";
const requireAuth = (to, from, next) => {
  let path = to.path;
  let split = path.split("/");
  store.dispatch("setPath", split[1]);
  store.dispatch("setFullPath", path);
  let token = ls.get("authen");
  if (!token) {
    next({
      path: "/login",
    });
  } else {
    next();
  }
};

const requireAuthV2 = (to, from, next) => {
  let path = to.path;
  let split = path.split("/");
  store.dispatch("setPath", split[1]);
  store.dispatch("setFullPath", path);
  next();
};

const requireAnyPermission = (requiredPermissions) => (to, from, next) => {
  let path = to.path;
  let split = path.split("/");
  store.dispatch("setPath", split[1]);
  store.dispatch("setFullPath", path);

  let token = ls.get("authen");
  if (!token) {
    next({ path: "/login" });
    return;
  }

  const accountInfo = store.getters["account/accountInfo"];
  if (!accountInfo || !Array.isArray(accountInfo.permissions)) {
    next();
    return;
  }

  const permissionNames = accountInfo.permissions.map((permission) => permission.name);
  if (requiredPermissions.some((permission) => permissionNames.includes(permission))) {
    next();
    return;
  }

  next({ name: "goods-home" });
};

export default {
  requireAuth,
  requireAuthV2,
  requireAnyPermission,
};
